const ITEMS = [
  "24/7 emergency legal access",
  "Contract & document review",
  "Will preparation",
  "Traffic ticket help",
  "Letters & calls on your behalf",
  "Trial defense hours",
  "Small business consultations",
  "Debt collection support",
];

export default function Marquee() {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-slate-500 px-8 whitespace-nowrap">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-blue-500/60" />
        </span>
      ))}
    </div>
  );

  return (
    <section className="bg-white border-y border-slate-200 py-6 overflow-hidden" data-testid="benefits-marquee" aria-label="Plan highlights">
      <div className="flex w-max animate-marquee">
        {row}
        <div aria-hidden="true" className="flex shrink-0 items-center">{row}</div>
      </div>
    </section>
  );
}
